import { createRoot } from 'react-dom/client';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import './i18n';
import App from './App';
import './index.css';

if (import.meta.env.DEV) {
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3001';
  console.log(`[Daily Reveal] ${import.meta.env.MODE} mode | API: ${apiUrl}`);
}

createRoot(document.getElementById('root')!).render(<App />);
